import React, { useContext, useMemo, useState } from 'react'
import { strCol, intCol } from '@integec/grid-tools/lib/cols'
import CommonScreen from '../CommonScreen'
import { connect } from 'react-redux'
import { Button, Input, InputNumber, message, Popconfirm } from 'antd'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'
import {
  getApiTargetInfo,
  getEnvConfig,
  getPermitActions,
} from 'core/selectors'
import * as api from '../../../api/pgads'
import { Filler, Label } from 'core/screen-util'
import * as ScreenPermissions from 'core/EventActions'
import { hasAccesPermits } from 'core/utils'
import { ErrorContext, JcTmpErrorContext, SpinContext } from 'context'
import { isErrorContains } from 'core/component/JcTmpErrorDialog'

const title = 'Asset Management'

export const getLabel = ({ style = {}, label, required }) => (
  <div>
    <Label
      style={{
        display: 'inline',
        float: 'right',
        width: '100%',
        textAlign: 'end',
        height: '100%',
        ...style,
      }}
    >
      {label} :
      {required && (
        <span style={{ color: 'red', marginRight: '2px', float: 'right' }}>
          *
        </span>
      )}
    </Label>
  </div>
)

const AssetManagement = ({ apiTargetInfo, actionPermits, envConfig }) => {
  const [insertEvent, setInsertEvent] = useState(false)
  const { setSpinning } = useContext(SpinContext)
  const { setTmpError } = useContext(JcTmpErrorContext)
  const { setError } = useContext(ErrorContext)

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '100px 300px 100px 300px 100px 300px 400px',
        gap: '10px',
      }}
    >
      {/* {getLabel({ label: 'Site', required: false })}
      <Input
        value={insertData.siteId}
        onChange={e => setInsertData({ ...insertData, siteId: e.target.value })}
      /> */}
      {getLabel({ label: 'Location', required: false })}
      <Input
        value={insertData.location}
        onChange={e =>
          setInsertData({ ...insertData, location: e.target.value })
        }
      />
      {getLabel({ label: 'SMEPA Id', required: true })}
      <Input
        value={insertData.smepaId}
        onChange={e =>
          setInsertData({ ...insertData, smepaId: e.target.value })
        }
      />
      {getLabel({ label: 'Asset Num', required: false })}
      <InputNumber
        style={{ width: '100%' }}
        value={insertData.assetNum}
        onChange={val => setInsertData({ ...insertData, assetNum: val })}
      />

      <div />
      {getLabel({ label: 'Description', required: false })}
      <Input.TextArea
        allowClear
        type="textarea"
        style={{ gridColumn: 'span 3' }}
        value={insertData.description}
        onChange={e =>
          setInsertData({ ...insertData, description: e.target.value })
        }
        autoSize={{ minRows: 1, maxRows: 4 }}
      />
      <div />
      <div
        style={{
          display: 'grid',
          // gridColumnEnd: 'span 3',
          gridTemplateColumns: 'auto auto auto',
          gap: 10,
        }}
      >
        <Button
          type="primary"
          onClick={() => onAdd(true)}
          style={{ marginLeft: '50px' }}
        >
          Add
        </Button>
        <Button type="primary" onClick={() => onAdd(false)}>
          Add & Hide
        </Button>

        <Button
          type="danger"
          onClick={onCancel}
          // style={{ marginLeft: '10px', marginRight: '20px' }}
        >
          Cancel
        </Button>
      </div>
    </div>
  )
  const hasAdminDataAccess = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits: actionPermits,
        eventActions: [ScreenPermissions.CHANGE_PERMISSIONS],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )
  const onDeleteALL = onRetrieve => {
    setSpinning(true)
    api.deleteALLAssetManagement(apiTargetInfo).fork(setError, res => {
      setSpinning(false)
      setTmpError(res)
      if (!isErrorContains(res)) {
        message.success('All Assets Deleted')
        onRetrieve()
      }
    })
  }

  const extraCriteriaAfterButton = ({ onRetrieve }) => {
    if (!hasAdminDataAccess) return <div />
    return (
      <Filler>
        <Popconfirm
          title="Are you sure you want to delete All Assets?"
          onConfirm={_ => onDeleteALL(onRetrieve)}
          okText="Yes"
          cancelText="No"
        >
          <Button type="danger">Delete All Assets</Button>
        </Popconfirm>
      </Filler>
    )
  }

  return (
    <CommonScreen
      extraCriteriaAfterButton={extraCriteriaAfterButton}
      withUnitSelection={false}
      isAdminScreen
      title={title}
      header={AssetManagementHeaders}
      initialSortOptions={AssetManagementHeaders}
      saveTask={api.saveAssetManagement}
      retrieveTask={api.getAssetManagement}
      deleteTask={api.deleteAssetManagement}
      autoRetrieve={false}
      sortOptions={AssetManagementHeaders}
      // widthOffset={100}
      insertCompHeight={50}
      insertComp={insertEvent && insertComp}
      onInsertEvent={b => setInsertEvent(b)}
      autoFixColByKey={false}
      withImport
      importUrl="screen-csv-import-file-parser"
      importData={{ importType: 'ASSET_MANAGEMENT' }}
      selectionMode="multi"
      // headerRowHeight={60}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
})

export default connect(mapStateToProps)(AssetManagement)

export const AssetManagementHeaders = [
  // strCol({
  //   ident: 'siteId',
  //   display: 'SITEID',
  //   width: 100,
  //   ellipsis: true,
  // }),
  strCol({
    ident: 'location',
    display: 'Location',
    width: 250,
    ellipsis: true,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'smepaId',
    display: 'Smepa ID',
    isKey: true,
    width: 250,
    ellipsis: true,
    sortOrder: 'asc',
  }),
  intCol({
    ident: 'assetNum',
    display: 'Asset ID',
    width: 200,
    ellipsis: true,
  }),
  strCol({
    ident: 'description',
    display: 'Description',
    width: 700,
    ellipsis: true,
  }),
  modifierCol,
  modifiedDateCol,
]
